import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import AICapabilities from '../components/AICapabilities';
import Integrations from '../components/Integrations';
import Services from '../components/Services';
import CaseStudies from '../components/CaseStudies';
import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950">
      <Hero />
      <Stats />
      <AICapabilities />
      <Integrations />
      <Services />
      <CaseStudies />
      <About />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
